import styled from 'styled-components';

export const GeneralAccContainer = styled.div`
  .MuiAccordion-root {
    box-shadow: none;
    margin-bottom: 0;
  }
  .MuiAccordionDetails-root {
    padding: 0;
  }
`;
